import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import './RankingManagementPage.css';
import RankingUpdatesTable from './RankingUpdatesTable';

const RankingManagementPage = () => {
  const navigate = useNavigate();

  return (
    <div className='page'>
      <div className='pageHeader'>Administración de Ranking</div>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, mb: 1 }}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/ranking-management/new')}
          sx={{
            borderRadius: 0,
            bgcolor: '#3a6eb6',
            '&:hover': { bgcolor: '#2563eb' },
          }}
        >
          Nuevo Cálculo
        </Button>
      </Box>
      <div style={{ marginTop: '8px' }}>
        <RankingUpdatesTable />
      </div>
    </div>
  );
};

export default RankingManagementPage;
